import React from "react";

import SectionLayoutGrid from "../../layouts/SectionLayoutGrid";
import Card from "../../cards/Card";

import {Header2} from "../../styled/typography/Typography";
import Col from "../../styled/grid/Col";
import {ButtonA, ButtonContainer, ButtonLink} from "../../styled/button/ButtonComponents";

const Functions = ({
                       big_title,
                       cards,
                       button_download,
                       button,
                       button_color,
                       isMultipleButton,
                       isExternal,
                       index
                   }) => {

    return (
        <SectionLayoutGrid customBackground="middle" id={index ? "Functions " + index : "Functions"}>
            <Col>
                <Header2 color="white" marginBottom="small">{big_title}</Header2>
            </Col>
            {cards && cards.map((item, index) => ((cards.length % 2 === 1 && index === cards.length - 1)
                    ?
                    (
                        <React.Fragment key={index}>
                            <Col span={3}/>
                            <Col span={6} grid>
                                <Card
                                    title={item.title}
                                    description={item.description}
                                    list={item.List}
                                    avatar={item.avatar.url}/>
                            </Col>
                        </React.Fragment>
                    )
                    :
                    (
                        <Col span={6} grid key={index}>
                            <Card
                                title={item.title}
                                description={item.description}
                                list={item.List}
                                avatar={item.avatar.url}
                            />
                        </Col>
                    )
            ))}
            {(button || button_download) && !isMultipleButton && !isExternal &&
            <Col center grid>
                <ButtonContainer>
                    {button && <ButtonLink to={button.link} color={button_color}>{button.name}</ButtonLink>}
                    {button_download &&
                    <ButtonA href={button_download.file.url} target="_blank" rel="noreferrer"
                             color="secondary-brand">{button_download.name}</ButtonA>}
                </ButtonContainer>
            </Col>
            }
            {button && isMultipleButton && !isExternal &&
            <Col center grid>
                <ButtonContainer>
                    <ButtonLink to={button[0].link} color={button_color}>{button[0].name}</ButtonLink>
                    <ButtonLink to={button[1].link} color="secondary-brand">{button[1].name}</ButtonLink>
                </ButtonContainer>
            </Col>
            }
            {button && isExternal && !isMultipleButton &&
            <Col center grid>
                <ButtonContainer>
                    <ButtonA href={button[0].link} target="_blank" rel="noreferrer"
                             color={button_color}>{button[0].name}</ButtonA>
                </ButtonContainer>
            </Col>
            }
        </SectionLayoutGrid>
    )
}

export default Functions